<!-- TEMPLATE -->
<template>
  <div :class="'dean-input-field' + (isEmpty ? ' empty' : '')">
    <input
            v-if="passwordShow === false"
            :type="deanInputFieldType"
            :class="validationClass"
            :name="name"
            :id="id"
            v-model="inputValue"
            @input="updateValue($event.target.value)"
            @keyup.enter="enterPressed"
            :tab-index="tabIndex"
            :disabled="deanInputFieldDisabled"
            @focus="onfocus(label)"
            @blur="onblur(label)"
            :step="step"
            :max="max"
            :min="min"/>
    <input
            v-if="passwordShow == true"
            type="text"
            :name="name"
            :id="id"
            class="show-password-focus"
            v-model="inputValue"
            @input="updateValue($event.target.value)"
            @keyup.enter="enterPressed"
            :tab-index="tabIndex"
            :disabled="deanInputFieldDisabled"
            @focus="onfocus(label)"
            @blur="onblur(label)"/>
    <div
            v-if="deanInputFieldType === 'password'"
            :class="showPasswordClass"
            @click="passwordShowClick()">
      <dean-icon
              :glyph="detailsIcon"
              :height="15"
              :width="15">
      </dean-icon>
    </div>
    <div
            v-if="disabled"
            class="disabled">
      <dean-icon
              class="icon"
              :glyph="forbiddenIcon"
              :height="15"
              :width="15">
      </dean-icon>
    </div>
    <span :class="labelClass">
      <span :class="labelTextClass">
        <slot></slot>
      </span>
      <span
              v-if="requiredField"
              class="required-field">
        *
      </span>
    </span>
    <span :class="labelClass" v-if="type == 'time'">00:00</span>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

  import {
    detailsIcon,
    forbiddenIcon,
  } from '@deanone/dean-components';
  import deanIcon from './deanIcon.vue';

  @Component({
    components: {
      deanIcon,
    },
  })

  export default class DeanInputField extends Vue {
    // PROPS
    @Prop({default: ''}) protected value!: string;
    @Prop({default: true}) protected text!: boolean;
    @Prop({default: false}) protected disabled!: boolean;
    @Prop({default: false}) protected password!: boolean;
    @Prop({default: false}) protected number!: boolean;
    @Prop({default: false}) protected warning!: boolean;
    @Prop({default: false}) protected requiredField!: boolean;
    @Prop({default: ''}) protected type!: string;
    @Prop({default: ''}) protected validation!: string;
    @Prop({default: ''}) protected label!: string;
    @Prop({default: ''}) protected id!: string;
    @Prop({default: ''}) protected name!: string;
    @Prop() protected tabIndex!: number;
    @Prop({default: ''}) protected min!: string;
    @Prop({default: ''}) protected max!: string;
    @Prop({default: ''}) protected step!: string;

    // DATA
    public detailsIcon: object = detailsIcon;
    public forbiddenIcon: object = forbiddenIcon;
    public passwordShow: boolean = false;
    public hideLabel: boolean = false;
    public inputValue = this.value;
    // @ts-ignore-next-line
    public slotText = String(this.$slots.default[0].text.replace(/\s+/g, ''));
    public isEmpty = (this.value === null || this.value === undefined || this.value === '');

    @Watch('value')
    public checkIfEmpty() { // TODO doesn't work if parent changes prop value to 0
      this.isEmpty = (this.value === null || this.value === undefined || this.value === '');
      this.inputValue = this.value;
    }

    @Watch('inputValue')
    public inputValueChange(value: any) {
      this.isEmpty = (this.value === null || this.value === undefined || this.value === '');
      this.inputHasValue(value);
      const inputData = {
        id: this.id,
        label: this.label,
        value,
      };

      if (this.label === '') {
        inputData.label = this.slotText;
      }

      this.$emit('inputData', inputData);
    }

    // EMIT
    @Emit('input')
    public updateValue(value: any) {
      this.hideLabel = !!((value !== '')
        && (value != null));
    }

    public enterPressed() {
      this.$emit('enter');
    }

    // COMPUTED
    get deanInputFieldType() {
      let value = '';

      if (this.text) {
        value = 'text';
      }

      if (this.password) {
        value = 'password';
      }

      if (this.number) {
        value = 'number';
      }

      if (this.type) {
        value = `${this.type}`;
      }
      return value;
    }

    get deanInputFieldDisabled() {
      let value = false;

      if (this.disabled) {
        value = true;
      }
      return value;
    }


    get validationClass() {
      let value = '';

      if (this.warning) {
        value = 'warning';
      }

      if (this.validation) {
        value = `${this.validation}`;
      }
      return value;
    }

    get showPasswordClass() {
      if (this.passwordShow) {
        return 'show-password show-password-active';
      } else {
        return 'show-password';
      }
    }

    get labelClass() {
      let value = 'label';
      if (this.hideLabel) {
        value += ' shrink-label';
      }
      return value;
    }

    get labelTextClass() {
      let value = 'label-text';
      if (this.type === 'time') {
        value += ' shrink-label';
      }
      return value;
    }

    // METHODS
    public inputHasValue(value: any) {
      this.hideLabel = !!((value !== '')
        && (value != null));
    }

    public passwordShowClick() {
      this.passwordShow = !this.passwordShow;
    }

    public onfocus(label: any) {
      this.$emit('focus', true);
    }

    public onblur(label: any) {
      this.$emit('focus', false);
    }

    public created() {
      this.inputHasValue(this.inputValue);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  // DEAN INPUT FIELD
  .dean-input-field {

    &.empty input {
      &:not(:focus)::-webkit-datetime-edit {
        color: transparent;
      }
      &[type="date"]:not( :focus ) {
        color: transparent;
      }
    }

    @include display-flex();
    justify-content: flex-end;
    align-content: center;
    position: relative;
    width: 100%;
    padding: 5px 10px 5px 10px;

    input {
      padding: 10px;
      height: 40px;
      background: none;
      background: linear-gradient(to left, white 50%, var(--color-light-shade-3, $color-light-shade-3) 50%);
      background-size: 200% 100%;
      background-position: right bottom;
      border: 1px solid var(--color-light-shade-1, $color-light-shade-1);
      width: 100%;
      //@include calc(width, "100% - 20px")
      @include border-radius(10px);
      @include transition(all ease 0.8s);

      &:focus {
        outline: none;
        background-position: left bottom;
        box-shadow: 0 0 10px 2px var(--color-secondary, $color-secondary);
        padding: 18px 10px 2px 10px;
      }

      &:-webkit-autofill {
        border: 1px solid var(--color-autofill, $color-autofill);
      }

      &:-webkit-autofill ~ .label {
        top: -1px;
        font-size: 7.5pt;
        color: var(--color-autofill-dark, $color-autofill-dark);
      }

      &:-webkit-autofill ~ .show-password {
        fill: var(--color-autofill-dark, $color-autofill-dark);
      }

      &:-webkit-autofill ~ .show-password-active {
         fill: var(--color-secondary, $color-secondary);
      }

      &:focus ~ .label {
        top: -1px;
        font-size: 7.5pt;
        color: var(--color-secondary, $color-secondary);
      }

      &[value=""] ~ .label {
        opacity: 1;
      }
      &:disabled {
        color: var(--color-dark-shade-4, $color-dark-shade-4);
        font-family: "Avenir-Medium", Tahoma, Helvetica, sans-serif;
        cursor: not-allowed;
        //font-weight: bold;
      }
    }

    .label {
      position: absolute;
      left: 10px;
      top: 5px;
      height: 30px;
      padding: 10px;
      font-family: "Avenir-Medium", Tahoma, Helvetica, sans-serif;
      user-select: none;
      color: var(--color-dark-shade-4, $color-dark-shade-4);;
      pointer-events: none;
      overflow: hidden;
      @include opacity (1, 0.8s);
      @include transition(all ease 0.4s);
      @include text-select-none();

      .required-field {
        color: var(--color-info-danger, $color-info-danger);
      }
    }

    .shrink-label {
      top: -1px;
      font-size: 7.5pt;
      opacity: 1;
    }


    .warning {
      border: 1px solid var(--color-info-warning, $color-info-warning);
    }

    .disabled {
      display: inline-flex;
      position: absolute;
      justify-content: flex-end;
      align-content: center;
      padding: 12.5px;
      height: 40px;
      width: 40px;
      cursor: not-allowed;
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
      @include border-radius(100px);

      .icon {
        background: white-alpha;
      }
    }

    .show-password {
      display: inline-flex;
      position: absolute;
      justify-content: flex-end;
      align-content: center;
      padding: 12.5px;
      cursor: pointer;
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
    }

    .show-password-active {
      fill: var(--color-secondary, $color-secondary);
    }

    .show-password-focus {
      box-shadow: 0 0 10px 2px var(--color-info-standard-bg, $color-info-standard-bg);
    }

    &:not(.empty) {
      input:not(:focus) ~ .label {
        opacity: 0;
      }
    }
  }

</style>
